module.exports = __webpack_public_path__ + "static/media/nike-the-ball-makes-us-more.f7d20b9c.mp4";